import React, { useState } from "react";
import SearchFilter from "../../Common/SearchFilter";
import { Block } from "../LibraryBuildingBlocks";

type SearchFilterExample = {
    id: string;
    name: string;
    country: string;
};

const exampleSearchItems: SearchFilterExample[] = [
    {
        id: "test1",
        name: "Mr FooBar",
        country: "Helsinki",
    },
    {
        id: "test2",
        name: "Mrs World Traveller",
        country: "Japan",
    },
];

function SearcFilterExamples() {
    const [exampleSearchResult, setExampleSearchResult] = useState<
        SearchFilterExample[] | null
    >(null);
    const [exampleSearchTerm, setExampleSearchTerm] = useState<string>("");

    return (
        <Block title="Search filter">
            <SearchFilter<SearchFilterExample>
                placeholder="Search by name or country"
                items={exampleSearchItems}
                predicates={[(example) => example.name, (example) => example.country]}
                onChange={({ isNewResult, matches, term }) => {
                    if (isNewResult) {
                        setExampleSearchResult(matches);
                    }
                    setExampleSearchTerm(term);
                }}
            />

            <br />
            <h4>Results with search term: {`"${exampleSearchTerm}"`}</h4>
            {(exampleSearchResult || exampleSearchItems).map((it) => (
                <div key={it.id}>{`${it.name} - ${it.country}`}</div>
            ))}
        </Block>
    );
}

export default SearcFilterExamples;
